import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./OurServices.css";

import Img1 from "../../images/Image-1.jpg";
import care1 from "../../images/Homecare.jpg";
import Acco1 from "../../images/Accounts-1.jpg";
import Soft1 from "../../images/rotacare.jpg";
import Opra1 from "../../images/New Business Set Up.jpg";

const Services = () => {
  const navigate = useNavigate();

  // Open page at the top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="OurServices">
      <h1 className="OurServices-title">
        Building Confidence in Compliance
      </h1>

      <p className="OurServices-pera">
        Total Care Advisory delivers trusted consultancy that care providers
        can rely on when it matters most.
        <br />
        <br />
        We understand the pressures of a busy care environment and provide
        expert guidance that helps services stay compliant, improve standards,
        and move forward with confidence.
      </p>

      <div className="btn-container">
        <button className="OurServices-btn">
          <a
            href="https://flipbook.so/flip/jUUmHzGAoWFTRgkf2a8U"
            target="_blank"
            rel="noopener noreferrer"
          >
            Link to Brochure
          </a>
        </button>
      </div>

      {/* Services */}
      <section className="our-services">
        <h2 className="our-services__heading">Services</h2>

        <p className="our-services__description">
          We offer a range of specialized services tailored to meet your
          individual needs. Our approach is focused on understanding
          <br />
          and responding to what you require, providing effective and practical
          solutions.
        </p>

        <div className="our-services__container">
          <div className="our-services__list">

            {/* CQC Services */}
            <div className="our-services__item">
              <div className="service-card">
                <div className="service-card__image service-card__CQCServices"></div>

                <div className="service-card__content">
                  <div className="service-card__title">CQC Services</div>

                  <p className="service-card__text">
                    We can support with the complexities of compliance and
                    regulation!
                  </p>

                  <div className="btn-container">
                    <button
                      id="Service-btn"
                      onClick={() =>
                        navigate("/Sub-Pages/CQC_Services")
                      }
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Care Home Sales */}
            <div className="our-services__item">
              <div className="service-card">
                <div className="service-card__image service-card__CareHomeSales"></div>

                <div className="service-card__content">
                  <div className="service-card__title">
                    Care Home Sales
                  </div>

                  <p className="service-card__text">
                    Professional support for buying, selling, and valuing
                    care homes.
                  </p>

                  <div className="btn-container">
                    <button
                      id="Service-btn"
                      onClick={() =>
                        navigate("/Sub-Pages/Care_Sell")
                      }
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Accounting */}
            <div className="our-services__item">
              <div className="service-card">
                <div className="service-card__image service-card__Accounting"></div>

                <div className="service-card__content">
                  <div className="service-card__title">Accounting</div>

                  <p className="service-card__text">
                    Financial management, bookkeeping, payroll, and tax
                    services.
                  </p>

                  <div className="btn-container">
                    <button
                      id="Service-btn"
                      onClick={() =>
                        navigate("/Sub-Pages/Acc_Capital")
                      }
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Software */}
            <div className="our-services__item">
              <div className="service-card">
                <div className="service-card__image service-card__Software"></div>

                <div className="service-card__content">
                  <div className="service-card__title">Software</div>

                  <p className="service-card__text">
                    Digital solutions designed to streamline care operations.
                  </p>

                  <div className="btn-container">
                    <button
                      id="Service-btn"
                      onClick={() =>
                        navigate("/Sub-Pages/Soft_Rota")
                      }
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Operational Management */}
            <div className="our-services__item">
              <div className="service-card">
                <div className="service-card__image service-card__OperationalManagement"></div>

                <div className="service-card__content">
                  <div className="service-card__title">
                    Operational Management
                  </div>

                  <p className="service-card__text">
                    Guidance and support to improve efficiency and quality.
                  </p>

                  <div className="btn-container">
                    <button
                      id="Service-btn"
                      onClick={() =>
                        navigate("/Sub-Pages/Opera_fullManag")
                      }
                    >
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Additional Support */}
      <section>
        <div className="Support-card">
          <h1 className="Support-title">
            We can also support with...
          </h1>

          <div className="Support-container">

            {/* CQC Services */}
            <section className="Support-section">
              <div className="Support-image">
                <img src={Img1} alt="CQC Services" />
              </div>

              <div className="Support-box">
                <h2>CQC Services</h2>

                <p>
                  Our expert consultants guide you through every stage of the
                  Care Quality Commission (CQC) process, from registration and
                  compliance to inspections and ongoing quality improvement.
                  We help ensure your service meets regulatory standards with
                  confidence.
                </p>

                <button
                  id="Service-btn"
                  onClick={() =>
                    navigate("/Sub-Pages/CQC_Services")
                  }
                >
                  Read More
                </button>
              </div>
            </section>

            {/* Care Home Sales */}
            <section className="Support-section reverse">
              <div className="Support-image">
                <img src={care1} alt="Care Home Sales" />
              </div>

              <div className="Support-box">
                <h2>Care Home Sales</h2>

                <p>
                  Our Care Home Sales service provides expert guidance
                  throughout the buying and selling process, helping owners
                  maximise value, ensure compliance, and achieve smooth,
                  confidential transactions with confidence and clarity.
                </p>

                <button
                  id="Service-btn"
                  onClick={() =>
                    navigate("/Sub-Pages/Care_Sell")
                  }
                >
                  Read More
                </button>
              </div>
            </section>

            {/* Accountancy */}
            <section className="Support-section">
              <div className="Support-image">
                <img src={Acco1} alt="Accountancy Services" />
              </div>

              <div className="Support-box">
                <h2>Accountancy Services</h2>

                <p>
                  Our specialist Accountancy Services for the care industry
                  provide tailored financial support, helping providers manage
                  finances efficiently, maintain compliance, improve
                  profitability, and make informed decisions for sustainable
                  long-term growth.
                </p>

                <button
                  id="Service-btn"
                  onClick={() =>
                    navigate("/Sub-Pages/Acc_Capital")
                  }
                >
                  Read More
                </button>
              </div>
            </section>

            {/* Software */}
            <section className="Support-section reverse">
              <div className="Support-image">
                <img src={Soft1} alt="Software" />
              </div>

              <div className="Support-box">
                <h2>Software</h2>

                <p>
                  Our care sector software solutions streamline scheduling,
                  governance, auditing. Our full ERP system provides all-round
                  efficiency to maintain compliance, enhance oversight, and
                  deliver better outcomes across their organisations.
                </p>

                <button
                  id="Service-btn"
                  onClick={() =>
                    navigate("/Sub-Pages/Soft_Rota")
                  }
                >
                  Read More
                </button>
              </div>
            </section>

            {/* Training */}
            <section className="Support-section">
              <div className="Support-image">
                <img src={Opra1} alt="Training" />
              </div>

              <div className="Support-box">
                <h2>operational management</h2>

                <p>
                 We provide expert operational management support to help care providers improve efficiency,
                  maintain compliance, and deliver consistently high-quality care. From reviewing day-to-day 
                  processes and workforce management to strengthening policies, procedures, and performance, 
                  we help you build a more effective and sustainable care operation.
                </p>

                <button
                  id="Service-btn"
                  onClick={() =>
                    navigate("/Sub-Pages/Opera_fullManag")
                  }
                >
                  Read More
                </button>
              </div>
            </section>

          </div>
        </div>
      </section>
    </section>
  );
};

export default Services;